export function computeDebitCredit(row) {
    if (row.amountSigned) {
        row.debit = row.amountSigned > 0 ? row.amountSigned : 0
        row.credit = row.amountSigned < 0 ? -row.amountSigned : 0
    }
}
